"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcUser = exports.OidcUserStatus = void 0;
const react_1 = require("react");
const vanillaOidc_js_1 = require("./vanilla/vanillaOidc.js");
var OidcUserStatus;
(function (OidcUserStatus) {
    OidcUserStatus["Unauthenticated"] = "Unauthenticated";
    OidcUserStatus["Loading"] = "Loading user";
    OidcUserStatus["Loaded"] = "User loaded";
    OidcUserStatus["LoadingError"] = "Error loading user";
})(OidcUserStatus = exports.OidcUserStatus || (exports.OidcUserStatus = {}));
const useOidcUser = (configurationName = 'default') => {
    const [oidcUser, setOidcUser] = (0, react_1.useState)({ user: null, status: OidcUserStatus.Unauthenticated });
    const oidc = vanillaOidc_js_1.VanillaOidc.get(configurationName);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        if (oidc && oidc.tokens) {
            setOidcUser(Object.assign(Object.assign({}, oidcUser), { status: OidcUserStatus.Loading }));
            oidc.userInfoAsync()
                .then((info) => {
                if (isMounted) {
                    // @ts-ignore
                    setOidcUser({ user: info, status: OidcUserStatus.Loaded });
                }
            })
                .catch(() => setOidcUser(Object.assign(Object.assign({}, oidcUser), { status: OidcUserStatus.LoadingError })));
        }
        return () => { isMounted = false; };
    }, []);
    return { oidcUser: oidcUser.user, oidcUserLoadingState: oidcUser.status };
};
exports.useOidcUser = useOidcUser;
//# sourceMappingURL=User.js.map